<template layout>
	<content-wrapper>
		<ui-alert variant="informative">
			We are still in beta phase, development of the dashboard is still in progress.<br />
			If you have any suggestions or feedback, please let us know.
		</ui-alert>
	</content-wrapper>
</template>
